import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";
import { cacheExchange, Client, createClient, dedupExchange, fetchExchange, Provider } from "urql";

import schema from "../generated/schema";
import { getRequestHeaders } from "../utils/getRequestHeaders";
import { fetchOptionsExchange } from "./fetchOptionsExchange";
import scalarExchange from "./scalarExchange";
import { SCALAR_MAPPING } from "./scalarMapping";

export const UrqlClientProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { isAuthenticated } = useAuth0();

    const urqlClient = useMemo(
        (): Client =>
            createClient({
                url: `${process.env.NEXT_PUBLIC_API_URL}graphql`,
                exchanges: [
                    dedupExchange,
                    scalarExchange({
                        schema,
                        scalars: SCALAR_MAPPING,
                    }),
                    cacheExchange,
                    fetchOptionsExchange(async (fetchOptions) => {
                        const headers = await getRequestHeaders(fetchOptions?.headers, !isAuthenticated);
                        return { ...fetchOptions, headers };
                    }),
                    fetchExchange,
                ],
            }),
        [isAuthenticated],
    );

    return <Provider value={urqlClient}>{children}</Provider>;
};
